import React, { Component } from "react";
import { Layout, Form, Input, Select, Button, message, Modal} from "antd";
import Header from "../../components/header";
import { reqAddCheck, reqCategory, reqEditCheck, reqAddEnit, reqSkillDetail, reqUpload} from "../../api";
import './ComEdit.less'

const { Content } = Layout;
const { Option } = Select;
const { TextArea } = Input;
const { Sider } = Layout;

/**
 * 综合考核新增编辑路由组件
 */
export class Edit extends Component {

    state = {
        redactId: '',
        paperId: '',
        redact: {},
        category: [],
        add: 'none',
        questionAuto: [{ answer: "", question: "" }],
        imgId: '',
        updatevisible111:false
    };

    imgClick = () => {
        document.getElementById("upload").click();
    };

    inputImg = async (e) => {
        let file = e.target.files[0];   //选择的图片文件
        let data = new FormData();
        data.append('file', file);

        let fileMaxSize = 1024 * 2;//2M
        let size = file.size / 1024;
        if (size > fileMaxSize) {
            message.error("图片大小不能大于2M！");
        } else {
            const result = await reqUpload(data);
            this.setState({
                imgId: result.data
            });
        }
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({
            updatevisible111: true
        })
    }

    handleCancel = () => {
        this.setState({
            updatevisible111: false,
        });
    };

    updatehandleOk = (e) =>{
        this.handleSubmit1(e)
    }

    handleSubmit1 = (e) => {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                let optArr = values.options.split('\n');
                let option = [];
                for (let i = 0; i < optArr.length; i++) {
                    option[i] = { "optionKey": String.fromCharCode(65 + i), "optionValue": optArr[i] };
                }
                let data = {
                    "questionType": values.questionType,
                    "imgs": [this.state.imgId],
                    "options": option
                };
                const que = [];
                const ans = [];
                const ids = [];
                const testQ = /^(question)\d$/;
                const testA = /^(answer)\d$/;
                const testI = /^(id)\d$/;
                for (const key in values) {
                    if (testQ.test(key)) {
                        que.push(values[key]);
                    }
                    if (testA.test(key)) {
                        ans.push(values[key]);
                    }
                    if (testI.test(key)) {
                        ids.push(values[key]);
                    }
                }
                let question = [];
                for (let i = 0; i < que.length; i++) {
                    question[i] = { "question": que[i], "correctAnswer": ans[i], "id": ids[i] };
                }
                data["questions"] = question;
                let result = '';
                let mes = "";
                if (this.state.redactId === 'none' || this.state.redactId === "") {
                    result = await reqAddCheck(values.categoryId, data);
                    mes = "添加";
                } else {
                    // paperId  试卷id
                    data["refId"] = values.id;
                    // console.log(this.state.paperId(65),this.state.redactId(189),values.categoryId(2));
                    result = await reqAddEnit(this.state.paperId, this.state.redactId, values.categoryId, data);
                    mes = "修改";
                }
                if (result.code === '000000') {
                    message.success(mes + "成功");
                    this.props.history.push("/previewCom");
                    // window.location.reload();
                }
            }
        });
    };

    collectAll = () => {
        const { getFieldValue, resetFields } = this.props.form;
        const questionAuto = [];
        let managerNumber = this.state.questionAuto.length;
        for (let i = 0; i < managerNumber; i++) {
            let answer = getFieldValue(`answer${i}`);
            let question = getFieldValue(`question${i}`);
            let id = getFieldValue(`id${i}`);
            //！！！！重要，如果不加此方法，则会在删除元素时，getFieldDecorator的initalValue属性不生效的问题
            resetFields([`answer${i}`, `question${i}`]);
            questionAuto.push({ answer: answer, question: question, id: id });
        }
        return questionAuto;
    };

    onLinkWay = (index, type) => {
        let questionAuto = this.collectAll();
        if (type === 'add') {
            questionAuto.push({ answer: "", question: "" });
        } else {
            questionAuto.splice(index, 1);
        }
        // console.log(questionAuto)
        this.setState({ questionAuto });
    };

    getCategoryList = async (type) => {
        const result = await reqCategory(type);
        if (result.code === '000000') {
            this.setState({
                category: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };

    getredactDetail = async (id) => {
        const result = await reqSkillDetail(id);
        const data = result.data;
        let options = '';
        for (let i = 0; i < data.options.length; i++) {
            options += data.options[i].optionValue;
            if (i < data.options.length - 1) {
                options += "\n"
            }
        }
        data.options = options;
        if (data.imgs) {
            this.state.imgId = data.imgs[0]
        }
        let questionAuto = [];
        const questions = data.questions;
        if (questions) {
            for (let i = 0; i < questions.length; i++) {
                questionAuto[i] = ({ answer: questions[i].correctAnswer, question: questions[i].question, id: questions[i].id })
            }
        } else {
            questionAuto = this.state.questionAuto;
        }
        this.setState({
            redact: data,
            questionAuto: questionAuto,
        });
    };

    selectChange = e => {
        if (e === 'B') {
            this.setState({
                add: 'inline-block'
            })
        } else {
            this.setState({
                add: 'none'
            })
        }
    };

    backToList = () => {
        this.props.history.goBack();
    };

    componentDidMount = async () => {
        let redactId = sessionStorage.getItem("redactId");
        let paperId = sessionStorage.getItem("paperId");
        if (redactId !== 'none') {
            this.setState({
                redactId: redactId,
                paperId: paperId
            });
            this.getredactDetail(redactId);
        }
        this.getCategoryList("CASE");
    };

    componentWillUnmount() {
        this.setState = (state, callback) => {
            return state;
        }
    }

    render() {
        const { redact, category, questionAuto, add,updatevisible111 } = this.state;
        const { getFieldDecorator } = this.props.form;
        let self = this;

        return (
            <Layout>
                <Header>Header</Header>
                <Layout>
                    <Sider>
                        <div className='type_q'>
                            <span>
                                综合考核试题
                            </span>
                        </div>
                    </Sider>
                    <Content>
                        <div className='edit_box'>
                            <div style={{ fontSize: "20px" }}> <span style={{ color: "red" }}>注意：</span> 本次编辑会在题库中生成对应的新题目，同时替换本试卷中的原始题目<br/>（原始题目仍在题库中保留，可用于其他试卷继续使用）</div>
                            <Form onSubmit={this.handleSubmit} className='edit_form'>
                                <Form.Item hidden>
                                    {getFieldDecorator('id', {
                                        initialValue: redact.id,
                                    })(<Input hidden />)}
                                </Form.Item>
                                <Form.Item label={'题型分类'} className='line' style={{ fontSize: "18px", marginLeft: '20px' }}>
                                    {redact.questionType}型题
                                    {getFieldDecorator('questionType', {
                                        initialValue: redact.questionType,
                                        rules: [{ required: true, message: '请选择题型分类!' }]
                                    })}
                                </Form.Item>
                                <Form.Item label={'试题分类'} className='line'>
                                    {getFieldDecorator('categoryId', {
                                        initialValue: redact.categoryId,
                                        rules: [{ required: true, message: '请选择试题分类!' }]
                                    })(
                                        <Select className='edit_select'>
                                            {
                                                category && category.map((item, index) => (
                                                    <Option key={index} value={item.id}>{item.name}</Option>
                                                ))
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                                <Form.Item>
                                    <div className='auto'>
                                        {
                                            questionAuto && questionAuto.map((item, index) => (
                                                <div key={index}>
                                                    <Form.Item label={'题干'} className='auto_q'>
                                                        {getFieldDecorator('question' + index, {
                                                            initialValue: item.question,
                                                            rules: [{ required: true, message: '请输入题干!' }]
                                                        })(<Input placeholder={'请输入题干'} className='edit_input'
                                                            autoComplete={"off"} />)}
                                                    </Form.Item>
                                                    <span style={{ display: add }} className='icons'>
                                                        {index < 2 && <button type={"button"}
                                                            onClick={() => self.onLinkWay(index, 'add')}>+</button>}
                                                        {index > 0 && <button type={"button"}
                                                            onClick={() => self.onLinkWay(index, 'minus')}>x</button>}
                                                    </span>
                                                    <Form.Item label={'正确答案'} labelCol={{ offset: 3 }}>
                                                        {getFieldDecorator('answer' + index, {
                                                            initialValue: item.answer,
                                                            rules: [{ required: true, message: '请输入正确答案!' }]
                                                        })(<Input placeholder={'如:A（多选请用|分开，如A|C）'} className='edit_input'
                                                            style={{ width: 300 }} autoComplete={"off"} />)}
                                                    </Form.Item>
                                                    <Form.Item hidden>
                                                        {getFieldDecorator('id' + index, {
                                                            initialValue: item.id,
                                                        })(<Input hidden />)}
                                                    </Form.Item>
                                                </div>
                                            ))
                                        }
                                    </div>
                                </Form.Item>
                                <Form.Item label="选项" wrapperCol={{ offset: 1 }}>
                                    {getFieldDecorator('options', {
                                        initialValue: redact.options,
                                        rules: [{ required: true, message: '请输入选项!' }],
                                    })(<TextArea className='edit_text' rows={4} placeholder={'请输入选项，一行一个选项'} />)}
                                </Form.Item>
                                <Form.Item wrapperCol={{ offset: 18 }}>
                                    <div className='img_list'>
                                        <img className='upload_img'
                                            src={this.state.imgId ? global.constant.uploadImage + this.state.imgId : require('../../assets/images/upload_img.png')}
                                            onClick={this.imgClick.bind(this)} />
                                        <Input name="file" accept="image/*" id="upload"
                                            type="file" style={{ opacity: 0, display: 'none' }}
                                            onChange={this.inputImg.bind(this)} />
                                    </div>
                                    <span>上传一张题干图片</span>
                                </Form.Item>
                                <Form.Item wrapperCol={{ offset: 10 }}>
                                    <Button className='edit_cancel' onClick={this.backToList.bind(this)}>
                                        取消
                                    </Button>
                                    <Button type="primary" htmlType="submit" className='edit_submit'>
                                        保存
                                    </Button>
                                </Form.Item>
                            </Form>
                        </div>
                        <Modal title="保存题目" visible={updatevisible111} onOk={this.updatehandleOk}
                            onCancel={this.handleCancel}
                            okText="确认" cancelText="取消" destroyOnClose='true'>
                            <div>确认保存当前编辑结果吗？</div>
                        </Modal>
                    </Content>
                </Layout>
            </Layout>
        )
    }
}

const WrapEdit = Form.create()(Edit);
export default WrapEdit;